import { FORM_SECTION } from 'entities/Form';
import i18n from 'i18n/i18n';

export const MAX_WIDTH_MOBILE = 696;

export const FORM_SECTION_LABELS: Record<FORM_SECTION, string> = {
  [FORM_SECTION.DEPARTMENT]: i18n.t('selectOutpatientService'),
  [FORM_SECTION.SPECIALTY]: i18n.t('selectSpecialty'),
  [FORM_SECTION.DOCTOR]: i18n.t('selectDoctor'),
  [FORM_SECTION.SERVICE]: i18n.t('selectServiceItem'),
  [FORM_SECTION.DATE_TIME]: i18n.t('appointmentTimeSlot'),
  [FORM_SECTION.PATIENT_FORM]: i18n.t('fillInInformation'),
  [FORM_SECTION.NULL]: '',
};
